export default __webpack_public_path__ + "static/media/release-notes.00647e48.png";